module.exports = __webpack_public_path__ + "media/images/lb/211-79edb4d21195e919184ec6344fba332f.svg";